import { Injectable } from '@angular/core';
import { CoreHttpService } from './core-http.service';

@Injectable()
export class CoreCurrencyService {
  constructor(private coreHttp: CoreHttpService) {}

  getAll() {
    return this.coreHttp.get<any[]>('Currencies/GetAll');
  }
}
